import { PdfLayout } from '../../shared/enum/EnumRepository';
import type { FloorPlanCaptionLayout } from './floorPlanA4PreviewTypes';

/** 세로 A4 · Column — 단(열) 개수 상한 */
export const FLOOR_PLAN_CAPTION_MAX_COLUMNS_PORTRAIT = 4;

/** 세로 A4 · Column — 단당 작품(블록) 개수 */
export const FLOOR_PLAN_CAPTION_BLOCKS_PER_COLUMN_PORTRAIT = 5;

/** 가로 A4 · Column — 단(열) 개수 상한 */
export const FLOOR_PLAN_CAPTION_MAX_COLUMNS_LANDSCAPE_COLUMN = 3;

/** 가로 A4 · Column — 단당 작품(블록) 개수 상한 */
export const FLOOR_PLAN_CAPTION_BLOCKS_PER_COLUMN_LANDSCAPE = 7;

/**
 * 미리보기 `captionSegmentCounts`·`documentFloorPlanPdfShared` 청크와 동일 규칙.
 * Row — 작품마다 한 줄(순서 1,2,3… 로만 위→아래), `segmentChunkSize: 1` · 총 슬롯은 Column 과 동일(20).
 */
export function getFloorPlanCaptionSlotPlan(
  pdfSheetLayout: PdfLayout,
  captionLayout: FloorPlanCaptionLayout
): { maxSlots: number; segmentChunkSize: number } {
  const isLandscape = pdfSheetLayout === PdfLayout.Horizontal;

  const maxRowSlots = FLOOR_PLAN_CAPTION_MAX_COLUMNS_PORTRAIT * FLOOR_PLAN_CAPTION_BLOCKS_PER_COLUMN_PORTRAIT;

  if (captionLayout === 'column') {
    if (isLandscape) {
      const maxCols = FLOOR_PLAN_CAPTION_MAX_COLUMNS_LANDSCAPE_COLUMN;
      const perCol = FLOOR_PLAN_CAPTION_BLOCKS_PER_COLUMN_LANDSCAPE;
      return { maxSlots: maxCols * perCol, segmentChunkSize: perCol };
    }
    return {
      maxSlots: maxRowSlots,
      segmentChunkSize: FLOOR_PLAN_CAPTION_BLOCKS_PER_COLUMN_PORTRAIT,
    };
  }

  return {
    maxSlots: maxRowSlots,
    segmentChunkSize: 1,
  };
}
